module.exports = __webpack_public_path__ + "img/updates-portal-icon.3f387618.png";